/**
 * 상품 즐겨찾기 — 기기별 로컬(localStorage). 백엔드 없이 별(★) 하나로 켜고 끈다.
 * 카탈로그가 company_product = '회사 카탈로그 전체' 구조라, 서버 즐겨찾기는 카탈로그를
 * 통째로 바꿔버려 안 맞는다. 회사 공유 즐겨찾기는 후속(BIZ-83)에서 별도 테이블로.
 */
const KEY = 'forbiz.favProducts'

function read(): Set<number> {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? '[]')
    return new Set(Array.isArray(raw) ? raw.filter((n): n is number => typeof n === 'number') : [])
  } catch {
    return new Set()
  }
}

function write(s: Set<number>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([...s]))
  } catch {
    /* 저장 실패(프라이빗 모드 등)는 조용히 넘어간다 — 이번 세션엔 적용돼 있다. */
  }
}

export function getFavorites(): number[] {
  return [...read()]
}

export function isFavorite(productId: number): boolean {
  return read().has(productId)
}

/** 켜고 끄기. 토글 후 상태(즐겨찾김=true)를 돌려준다. */
export function toggleFavorite(productId: number): boolean {
  const s = read()
  if (s.has(productId)) s.delete(productId)
  else s.add(productId)
  write(s)
  return s.has(productId)
}
